var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeatherShield(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 33,
    viewBox: "0 0 27 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1871",
    "data-name": "\\uADF8\\uB8F9 1871",
    transform: "translate(-915.889 -305.971)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-shield",
    "data-name": "Icon feather-shield",
    d: "M18,33s12-6,12-15V7.5L18,3,6,7.5V18C6,27,18,33,18,33Z",
    transform: "translate(911.389 304.471)",
    fill: "#545e77",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_map-locksmith",
    "data-name": "Icon map-locksmith",
    d: "M14.133,6.24h-.6V3.858A3.379,3.379,0,0,0,10.4.72H7.78A3.32,3.32,0,0,0,4.7,3.858V6.24h-.66A.592.592,0,0,0,3.6,6.7v7.027c0,.165.258.243.444.243H14.133c.187,0,.508-.078.508-.243V6.7a.675.675,0,0,0-.508-.458Zm-3.712,6.624H7.757l.559-2.751a1.427,1.427,0,0,1-.559-1.133A1.352,1.352,0,0,1,9.089,7.63a1.314,1.314,0,0,1,1.332,1.306,1.535,1.535,0,0,1-.558,1.186ZM11.6,6.24H6.636V3.858A1.129,1.129,0,0,1,7.807,2.652h2.564A1.179,1.179,0,0,1,11.6,3.858Z",
    transform: "translate(920.268 314.256)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatherShield);
export default __webpack_public_path__ + "static/media/feather_shield.81b6a0dafcc511d502d58cef0bafe6e9.svg";
export { ForwardRef as ReactComponent };